// src/components/Landing/Features.jsx
import React from 'react';
import { FeatureCard } from './FeatureCard';

const items = [
  {
    title: 'Tailored Solutions',
    body: 'Custom CMS built for your workflows, not generic templates.',
    icon: '🛠️',
  },
  {
    title: 'Scalable & Secure',
    body: 'Enterprise-level role management, secure APIs, and long-term scalability.',
    icon: '🔒',
  },
  {
    title: 'Easy to Use',
    body: 'Beautiful, intuitive dashboards your team can navigate instantly.',
    icon: '⚡',
  },
];

export const Features = () => {
  return (
    <div className="grid gap-8 md:grid-cols-3">
      {items.map((it, i) => (
        <FeatureCard key={it.title} index={i} {...it} />
      ))}
    </div>
  );
};
